<template>
    <v-card flat outlined>
        <v-data-table
            mobile-breakpoint="0"
            :headers="contactHeaders"
            :items="internalComs"
            hide-default-footer
            disable-sort
        >
            <!-- class="elevation-1" -->
            <template #[`item.icon`]="{ item }">
                <v-btn text icon color="primary" :href="item.value" target="_blank">
                    <v-avatar size="24">
                        <v-img contain :src="item.logo">
                            <template #placeholder>
                                <v-row class="fill-height ma-0" align="center" justify="center">
                                    <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
                                </v-row>
                            </template>
                        </v-img>
                    </v-avatar>
                </v-btn>
                
                <a :href="item.value" target="_blank" :dir="(item.displayValue && item.displayValue.indexOf('تحويلة') != -1) ? 'rtl': 'ltr'">
                    {{ item.displayValue }}
                </a>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
export default {
	props:{
		communications: {
			type: Array,
			default: () => []
		}
	},
	data(){
		return{
			internalComs: [],
			contactHeaders: [
				{ text: "الاسم", value: "name" },
				{ text: "الوصف", value: "note" },
				{ text: "تواصل", value: "icon" }
			],
		}
	},
	mounted(){
		this.internalComs = this.communications.map(
			comm => {
				if (comm.note == "null") {
					comm.note = null;
				}

				if (comm.name == "Telephone") {
					comm.displayValue = comm.value;
					comm.value = "tel:" + comm.value;
				} else if (comm.name == "الواتساب") {
					comm.displayValue = comm.value;
				} else if (comm.name == "رقم الجوال") {
					comm.displayValue = comm.value;
					comm.value = "tel:" + comm.value;
				} else if (comm.name == "البريد الإلكتروني") {
					comm.displayValue = comm.value;
					comm.value = "mailto:" + comm.value;
				} else if (comm.name == "الموقع الإلكتروني") {
					comm.displayValue = comm.value;
				} else {
					comm.displayValue = comm.value;
				}
				return comm;
			}
		);
		
	}

}
</script>

<style>

</style>